import { render, staticRenderFns } from "./MerchantAmount.vue?vue&type=template&id=a2edfee0&scoped=true"
import script from "./MerchantAmount.vue?vue&type=script&lang=js"
export * from "./MerchantAmount.vue?vue&type=script&lang=js"
import style0 from "./MerchantAmount.vue?vue&type=style&index=0&id=a2edfee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2edfee0",
  null
  
)

export default component.exports